import React, { useEffect, useRef } from "react";
import EditorJS from "@editorjs/editorjs";

import Header from "@editorjs/header";
import List from "@editorjs/list";
import Table from "@editorjs/table";
import Quote from "@editorjs/quote";
import CodeTool from "@editorjs/code";
import Paragraph from "@editorjs/paragraph";

const DEFAULT_DATA = {
  time: Date.now(),
  blocks: [],
  version: "2.30.0",
};

const isValidEditorData = (data) => {
  return (
    data &&
    typeof data === "object" &&
    Array.isArray(data.blocks)
  );
};

const CommonEditor = ({ value, onChange }) => {
  const editorRef = useRef(null);
  const editorInstance = useRef(null);

  // 🔹 Initialize editor only once
  useEffect(() => {
    if (editorInstance.current) return;

    const editor = new EditorJS({
      holder: editorRef.current,
      placeholder: "Start writing here...",
      data: DEFAULT_DATA, // ✅ always safe default
      tools: {
        paragraph: {
          class: Paragraph,
          inlineToolbar: true,
        },
        header: {
          class: Header,
          inlineToolbar: true,
          config: {
            levels: [1, 2, 3, 4, 5, 6],
            defaultLevel: 2,
          },
        },
        list: {
          class: List,
          inlineToolbar: true,
        },
        table: {
          class: Table,
          inlineToolbar: true,
          config: {
            rows: 2,
            cols: 3,
          },
        },
        quote: {
          class: Quote,
          inlineToolbar: true,
        },
        code: {
          class: CodeTool,
        },
      },
    //   async onChange(api) {
    //     const data = await api.saver.save();
    //     onChange?.(data);
    //   },
    });

    editorInstance.current = editor;

    return () => {
      editorInstance.current?.destroy();
      editorInstance.current = null;
    };
  }, []);

  // 🔹 Handle async value update safely
  useEffect(() => {
    if (!editorInstance.current) return;
    if (!isValidEditorData(value)) return;

    editorInstance.current.isReady
      .then(() => {
        editorInstance.current.render(value);
      })
      .catch((err) => {
        console.error("Render error:", err);
      });
  }, [value]);

  	const handleSave = async () => {
		if (!editorInstance.current) return;
		const savedData = await editorInstance.current.save(); onChange?.(savedData);
	};

  return (
    <div
      style={{
        border: "1px solid #ddd",
        padding: 15,
        borderRadius: 8,
      }}
    >
      <div ref={editorRef} />
	  <button onClick={handleSave} type="button" style={{ marginTop: 15, padding: "8px 15px", background: "#2563eb", color: "#fff", border: "none", borderRadius: 5, cursor: "pointer", }} > Save </button>
    </div>
  );
};

export default CommonEditor;